import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ReservationPage_content" }
const _hoisted_2 = {
  key: 0,
  class: "ReservationPage_currentReservation"
}
const _hoisted_3 = { class: "ui-txt-xl ReservationPage_date" }
const _hoisted_4 = { class: "ReservationPage_dataBox ui-txt-lg" }
const _hoisted_5 = { class: "ReservationPage_dataBoxLeft" }
const _hoisted_6 = { class: "ReservationPage_dataBoxRight" }
const _hoisted_7 = { class: "ReservationPage_dataBoxRight_content" }
const _hoisted_8 = { class: "ReservationPage_dataBox ui-txt-lg" }
const _hoisted_9 = { class: "ReservationPage_dataBoxLeft" }
const _hoisted_10 = { class: "ReservationPage_dataBoxRight" }
const _hoisted_11 = { class: "ReservationPage_dataBoxRight_content" }
const _hoisted_12 = { class: "ui-btn_label" }
const _hoisted_13 = {
  key: 1,
  class: "ReservationPage_newReservation"
}
const _hoisted_14 = { class: "ReservationPage_newReservationContainer" }
const _hoisted_15 = { class: "ui-txt-xl ReservationPage_date" }
const _hoisted_16 = { class: "ReservationPage_contentBottom" }
const _hoisted_17 = { class: "ui-btn_label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_background = _resolveComponent("app-background")!
  const _component_top_bar = _resolveComponent("top-bar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_dev_box = _resolveComponent("dev-box")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "ReservationPage" }, {
    default: _withCtx(() => [
      _createVNode(_component_app_background, {
        class: _normalizeClass({ 'is-green': _ctx.currentReservation })
      }, null, 8, ["class"]),
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_top_bar)
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_dev_box, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.store.state.currentDay.date), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, { class: "ReservationPage_container ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.currentReservation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("section", null, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.moment(_ctx.store.state.currentDay.date).locale(_ctx.store.state.user.language).format('LL')), 1)
                  ]),
                  _createElementVNode("section", null, [
                    _createElementVNode("span", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('ReservationPage.parkingSpace')) + ": ", 1),
                      _createElementVNode("span", _hoisted_6, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ReservationPage_dataBoxRight_stripe" }, null, -1)),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentReservation.parkingSpace.number), 1)
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('ReservationPage.floorNumber')) + ": ", 1),
                      _createElementVNode("span", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ReservationPage_dataBoxRight_stripe" }, null, -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentReservation.parkingSpace.floor), 1)
                      ])
                    ]),
                    (_ctx.isParkingMapEnabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "ReservationPage_mapButton ui-btn is-lg is-stretched",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleParkingMapClick && _ctx.handleParkingMapClick(...args)))
                        }, [
                          _createVNode(_component_ion_icon, { src: _ctx.mapOutline }, null, 8, ["src"]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('ReservationPage.parkingMap')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("section", null, [
                    _createElementVNode("span", {
                      class: "ReservationPage_cancelButton ui-btn is-lg is-stretched",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCancelClick(_ctx.currentReservation.id)))
                    }, [
                      _createVNode(_component_ion_icon, { src: _ctx.closeOutline }, null, 8, ["src"]),
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'ui-btn_label': true,
                  'is-disabled': _ctx.store.state.isDeletingReservation,
                })
                      }, _toDisplayString(_ctx.$t('ReservationPage.cancelReservation')), 3)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.moment(_ctx.store.state.currentDay.date).locale(_ctx.store.state.user.language).format('LL')), 1),
                    (_ctx.isCustomHoursSelected)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('ReservationPage.beginTime')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_datetime, {
                                "display-format": "HH:mm",
                                value: "2012-12-15T12:34:20.789"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('ReservationPage.endTime')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_datetime, {
                                "display-format": "HH:mm",
                                value: "2012-12-15T23:45:20.789"
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'ReservationPage_confirmButton': true,
                  'ui-btn': true,
                  'is-lg': true,
                  'is-disabled': _ctx.store.state.isPostingReservation,
                }),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleConfirmClick && _ctx.handleConfirmClick(...args)))
                      }, [
                        _createVNode(_component_ion_icon, { src: _ctx.checkmarkOutline }, null, 8, ["src"]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('ReservationPage.confirmReservation')), 1)
                      ], 2)
                    ])
                  ])
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}